(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cdvue", [], factory);
	else if(typeof exports === 'object')
		exports["cdvue"] = factory();
	else
		root["cdvue"] = factory();
})(window, function() {
return 